
import { defineComponent } from 'vue'
import { EThemeConcepts } from '@/services/theme'

import { Container } from '@/components/Container'
import { Heading } from '@/components/Heading'
import { Text } from '@/components/Text'
import { IconHeart } from '@/components/Icons'

export default defineComponent({
  name: 'SectionFooter',
  components: { Container, Heading, Text, IconHeart },
  setup: () => ({ EThemeConcepts }),
})
